"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledParagraph = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _recompose = require("recompose");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledParagraph = (0, _styledBase.default)("p", {
  target: "eyp8z7h0"
})(process.env.NODE_ENV === "production" ? {
  name: "u4md0b",
  styles: "margin:0 0 15px;line-height:1.5;"
} : {
  name: "u4md0b",
  styles: "margin:0 0 15px;line-height:1.5;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wYXJhZ3JhcGgvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3VDIiwiZmlsZSI6Ii4uLy4uL3NyYy9wYXJhZ3JhcGgvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjb21wb3NlLCBzZXREaXNwbGF5TmFtZSB9IGZyb20gJ3JlY29tcG9zZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQYXJhZ3JhcGggPSBzdHlsZWQucGBcbiAgbWFyZ2luOiAwIDAgMTVweDtcbiAgbGluZS1oZWlnaHQ6IDEuNTtcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbXBvc2Uoc2V0RGlzcGxheU5hbWUoJ1BhcmFncmFwaCcpKShTdHlsZWRQYXJhZ3JhcGgpO1xuIl19 */"
});
exports.StyledParagraph = StyledParagraph;

var _default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Paragraph'))(StyledParagraph);

exports.default = _default;